<div class="row">
  <div class="col-12">
    <form [formGroup]="gatewayForm" (submit)="createGateway(gatewayForm.value)">
      <div class="row">
        <!-- Nombre a todo el ancho -->
        <div class="col-12">
          <div class="floating-label">
            <input
              formControlName="name"
              type="text"
              class="form-control"
              placeholder=" "
              [class.is-invalid]="
                gatewayForm.get('name')?.invalid && gatewayForm.get('name')?.touched
              "
            />
            <span>{{ "tables.name" | translate }}</span>
          </div>
          <span
            class="text-danger"
            *ngIf="gatewayForm.get('name')?.invalid && gatewayForm.get('name')?.touched"
          >
            {{ "admin.admins.error-name" | translate }}
          </span>
        </div>
        <div class="col-6 mt-2">
          <div class="floating-label">
            <input
              formControlName="ip"
              type="text"
              class="form-control"
              placeholder=" "
              [class.is-invalid]="gatewayForm.get('ip')?.invalid && gatewayForm.get('ip')?.touched"
            />
            <span>{{ "tables.ip" | translate }}</span>
          </div>
          <span
            class="text-danger"
            *ngIf="gatewayForm.get('ip')?.invalid && gatewayForm.get('ip')?.touched"
          >
            {{ "admin.network-config.ip-required" | translate }}
          </span>
        </div>
        <div class="col-6 mt-2">
          <div class="floating-label">
            <input
              formControlName="port"
              type="text"
              class="form-control"
              placeholder=" "
              [class.is-invalid]="
                gatewayForm.get('port')?.invalid && gatewayForm.get('port')?.touched
              "
            />
            <span>{{ "tables.port" | translate }}</span>
          </div>
          <span
            class="text-danger"
            *ngIf="gatewayForm.get('port')?.invalid && gatewayForm.get('port')?.touched"
          >
            {{ "admin.network-config.port-required" | translate }}
          </span>
        </div>

        <!-- Distribucion del gateway -->
        <div class="col-12 mt-3">
          <div class="d-flex flex-column flex-wrap">
            <span>{{ "admin.clients.network.distribution" | translate }}</span>
            <div class="d-flex flex-wrap gap-10">
              <div class="form-check d-flex align-items-center">
                <input
                  class="form-check-input"
                  type="radio"
                  [checked]="gatewayForm.value.is_farm"
                  (change)="changevaluefarm()"
                  name="is_farm"
                  id="id_farm"
                />
                <p class="form-check-label" style="margin-top: 4px" for="id_farm">
                  {{ "admin.clients.network.all-farm" | translate }}
                </p>
              </div>
              <div class="form-check d-flex align-items-center">
                <input
                  class="form-check-input"
                  type="radio"
                  [checked]="!gatewayForm.value.is_farm"
                  (change)="gatewayForm.controls.is_farm.setValue(false)"
                  name="is_farm"
                  id="id_pond"
                />
                <p class="form-check-label" style="margin-top: 4px" for="id_pond">
                  {{ "admin.clients.network.for-ponds" | translate }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 mt-2" *ngIf="gatewayForm.value.is_farm">
          <span>{{ "admin.clients.network.farm-id" | translate }}</span>
          <input formControlName="farm" type="text" class="form-control" disabled />
        </div>
        <div class="col-12 mt-2" *ngIf="!gatewayForm.value.is_farm && allPonds">
          <div class="floating-label">
            <select
              class="form-control"
              placeholder=" "
              formControlName="pond"
              (change)="selectPond($event.target.value)"
            >
              <option value="">{{ "admin.network-config.select-pond" | translate }}</option>
              <option *ngFor="let item of allPonds; let i = index" [value]="i">
                {{ item.name }}
              </option>
            </select>
            <span>{{ "tables.pond" | translate }}</span>
          </div>
        </div>
        <div class="col-12 mt-2" *ngIf="!gatewayForm.value.is_farm && selectedPonds">
          <span
            *ngFor="let item of selectedPonds; let i = index"
            class="badge badge-secondary mr-2 c-pointer"
            (click)="selectedPonds.splice(i, 1)"
            >{{ item.name }}</span
          >
        </div>

        <div class="col-12 center mt-3">
          <div class="d-flex justify-content-center gap-20 flex-wrap">
            <div class="custom-control custom-switch">
              <input
                type="checkbox"
                class="custom-control-input"
                formControlName="enabled"
                id="enabled"
              />
              <label class="custom-control-label" for="enabled">
                <p class="mb-0" style="margin-top: 3px">
                  {{ "tables.status" | translate }} gateway
                </p>
              </label>
            </div>
            <div class="custom-control custom-switch c-pointer">
              <input
                type="checkbox"
                class="custom-control-input"
                formControlName="test"
                id="test"
              />
              <label class="custom-control-label" for="test">
                <p class="mb-0" style="margin-top: 3px">
                  {{ "admin.network-config.test-gateway" | translate }}
                </p>
              </label>
            </div>
          </div>
        </div>

        <div
          class="col-12 text-center mt-4 text-primary"
          style="word-break: break-all"
          *ngIf="generatedKey"
        >
          <p class="mb-0"><i class="fa fa-key"></i> {{ generatedKey }}</p>
        </div>
      </div>
    </form>
  </div>
</div>
